import React from 'react';
import PropTypes from 'prop-types';

const Error = ({ error }) => (
  <div>
    <h1>Error</h1>
    <p>{error}</p>
  </div>
);

Error.propTypes = {
  error: PropTypes.string,
};

export default Error;
